module.exports = __webpack_public_path__ + "static/assets/flase.07950fa7.png";